import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { relogin, handleLogout } from "@/store/actions/auth";

export default function useAuthWatcher() {
  const dispatch = useDispatch();
  const { accessToken, refreshToken, expiresAt } = useSelector((s) => s.auth);

  useEffect(() => {
    if (!accessToken || !expiresAt) return;

    const check = setInterval(() => {
      if (Date.now() >= expiresAt - 5 * 60 * 1000) {
        console.log('Token is about to expire, attempting to relogin...',expiresAt);
        dispatch(relogin());
      }
    }, 60 * 1000);

    return () => clearInterval(check);
  }, [accessToken, expiresAt, dispatch]);

  useEffect(() => {
    console.log('Checking token expiration...', expiresAt,Date.now() > expiresAt);
    if (expiresAt && Date.now() > expiresAt) {
      if (refreshToken) {
        dispatch(relogin());
      } else {
        dispatch(handleLogout());
      }
    }
  }, [expiresAt, refreshToken, dispatch]);
}
